import { on } from '@ember/modifier';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import EmberFlatpickr from 'ember-flatpickr/components/ember-flatpickr';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

import Button from 'umg-ember-backend/components/ui/button/index';
import { getBem } from 'umg-ember-backend/utils/get-bem';

import styles from './styles.module.css';

const bem = getBem(styles);

export default class UiFormFieldDatetimeComponent extends Component {
  // Services
  @service intl;

  // Getter and setter
  get locale() {
    if (!this.intl.locale) {
      return null;
    }

    return this.intl.locale[0];
  }

  get isResettable() {
    return this.args.value && !this.args.isDisabled && !this.args.isRequired;
  }

  get icon() {
    return this.args.icon ?? 'calendar';
  }

  get displayFormat() {
    return this.args.displayFormat ?? 'd.m.Y';
  }

  get inputFormat() {
    return this.args.inputFormat ?? 'Y-m-d';
  }

  get value() {
    return this.args.value ?? null;
  }

  // Actions
  setDate = (dateObjects, date) => {
    this.args.onChange(date);
  };

  resetDate = () => {
    this.args.onChange(null);
  };

  // Template
  <template>
    <div class={{(bem)}}>
      {{#if this.icon}}
        <div
          class={{bem 'icon'}}
          data-test-ui-form-field-datetime-icon={{this.icon}}
        >
          {{svgJar this.icon class='u-icon'}}
        </div>
      {{/if}}
      <div class={{bem 'picker'}}>
        <EmberFlatpickr
          placeholder={{@placeholder}}
          @allowInput={{false}}
          @altFormat={{this.displayFormat}}
          @altInput={{true}}
          @ariaDateFormat={{this.displayFormat}}
          @date={{this.value}}
          @dateFormat={{this.inputFormat}}
          @disabled={{@isDisabled}}
          @enableTime={{@enableTime}}
          @id={{@fieldId}}
          @locale={{this.locale}}
          @noCalendar={{@noCalendar}}
          @onChange={{this.setDate}}
          @time_24hr={{true}}
          @weekNumbers={{true}}
        />
      </div>
      {{#if this.isResettable}}
        <div class={{bem 'reset'}}>
          <Button
            @icon='close'
            @iconClass='u-color-error'
            @style='outline'
            {{on 'click' this.resetDate}}
          />
        </div>
      {{/if}}
    </div>
  </template>
}
